import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import LiveJunSvg from './utils/img/junior_livenew.svg';
import CoachSvg from './utils/img/step_coachnew.svg';
import LearnSvg from './utils/img/step_learnnew.svg';
import WorkProSvg from './utils/img/working_professionalnew.svg';
import LiveNewSvg from './utils/img/step_livenew.svg';
import TeachSvg from './utils/img/teaching_professionalnew.svg';
import Challenge from './utils/img/challenge_bac.png';
import Certificate from './utils/img/product_bg3.webp';
import Config from '../../config/Config';
import ListAnimation from '../utils/animations/list';
import { getRelatedCourses } from '../../redux/buyCourse/buyCourse.actions';
import { tagEvent } from '../../utils/tagManager';
const CardStyle = {
	COACH: {
		src: CoachSvg,
		style: { background: '#1C2D56' },
	},
	LEARN: {
		src: LearnSvg,
		style: { background: '#B29A22' },
	},
	WORKPRO: {
		src: WorkProSvg,
		style: { background: '#5B41EE' },
	},
	LIVE: {
		src: LiveNewSvg,
		style: { background: '#1C2D56' },
	},
	TEACHPRO: {
		src: TeachSvg,
		style: { background: '#1C2D56' },
	},
	LIVEJUNIOR: {
		src: LiveJunSvg,
		style: { background: '#ED1D7F' },
	},
	CHALLENGE: {
		style: {
			backgroundImage: `url(${Challenge})`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			color: '#1C2D56',
		},
	},
	CERTIFICATE: {
		style: {
			backgroundImage: `url(${Certificate})`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
		},
	},
};

const RecommendedProductCard = ({
	offer_price,
	original_price,
	product_icon_url,
	product_tag_line,
	product_id,
	product_name,
	product_type,
	isInternational,
	offer_price_usd,
	original_price_usd,
	product_name_slug,
	userId,
}) => {
	const originalPrice = isInternational ? original_price_usd : original_price;
	const offerPrice = isInternational ? offer_price_usd : offer_price;
	const currency = isInternational ? '$ ' : '₹ ';
	let offer_price_display = currency + offerPrice;
	let original_price_display = currency + originalPrice;

	const { style, src } = CardStyle[product_type];

	return (
		<div className="recommendedCard" style={{ ...style }}>
			<div>
				<div className="imgContainer">
					<img src={product_icon_url} className="img-responsive" alt="courseimg" />
				</div>
				<div>
					<div className="title">
						{product_name} - {product_tag_line}
					</div>
					<div className="price">
						<div className="originalPrice">
							{original_price_display}
							{original_price_display && <hr />}
						</div>

						<div className="offerPrice">{offer_price_display}</div>
					</div>
					{isInternational ? (
						<a
							href={`${Config.WEBSITEURL}product/${product_name_slug}`}
							target="_blank"
							className="buttonBuy"
							rel="noopener noreferrer"
						>
							Learn More
						</a>
					) : (
						<a
							href={`/purchase?productID=${product_id}`}
							className="buttonBuy"
							style={{ cursor: 'pointer' }}
							onClick={() =>
								tagEvent({
									event: 'recommended_product_click',
									user_id: userId,
									product_id,
									product_name,
									page: window.location.pathname.split('/')[1],
									type: 'webclient',
									platform: 'web',
								})
							}
						>
							Learn More
						</a>
					)}
				</div>
			</div>
			{src && <img className="productsvg" src={src} alt="svg" />}
		</div>
	);
};

const RecommendedList = ({
	relatedProductsList,
	isInternational,
	getRelatedCourses,
	userId,
}) => {
	useEffect(() => {
		getRelatedCourses();
	}, [getRelatedCourses]);
	return (
		<ListAnimation open={true} className="recommendCoursesContainer">
			<h4 className="section-body-title">Recommended Courses</h4>
			{typeof relatedProductsList !== 'undefined'
				? Object.keys(relatedProductsList).map((key) => {
						return key < 4 ? (
							<RecommendedProductCard
								isInternational={isInternational}
								key={relatedProductsList[key].product_id}
								{...relatedProductsList[key]}
								userId={userId}
							/>
						) : null;
				  })
				: null}
		</ListAnimation>
	);
};

const mapStateToProps = (state) => {
	const { relatedProductsList } = state.rootReducer.buyCourse;
	const { isInternational, userId } = state.rootReducer.loginDetails;
	return {
		relatedProductsList,
		isInternational,
		userId,
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getRelatedCourses: () => dispatch(getRelatedCourses()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(RecommendedList);
